import { lazy } from 'react';

export const PlayerRemoveSessionLimitForm = lazy(
  () => import('./PlayerRemoveSessionLimitForm'),
);
